<section aria-label="Gebiet">
  <div class="mb-3 flex flex-wrap items-end justify-between gap-x-6 border-b border-border">
    <h2 class="pb-2.5 text-base font-bold">Gebiet</h2>
    <app-tabs class="-mb-px !overflow-visible" label="Was die Karte zeigt" [ruled]="false" [items]="metrics" [value]="metric()" (valueChange)="pickMetric($any($event))" />
  </div>

  <div class="relative flex h-[clamp(34rem,72vh,48rem)] min-w-0 overflow-hidden rounded-md border border-border">
    @if (org.organization(); as current) {
      <!-- Leaflet and every address load only once the map scrolls into view. -->
      @defer (on viewport) {
        <app-solar-map [surface]="true" [paint]="paint()" [campaignId]="store.campaignId()!" [organizationId]="current.id" [organizationSlug]="current.slug" />
      } @placeholder {
        <div class="w-full animate-pulse bg-muted"></div>
      }
    }

    <!-- The charts sit on the map as a navy glass layer and filter it. -->
    <aside class="absolute right-3 top-3 z-10 flex max-h-[calc(100%-1.5rem)] w-72 flex-col gap-4 overflow-y-auto rounded-md border border-white/10 bg-ks-navy/70 p-3 text-white shadow-md backdrop-blur-md" aria-label="Auswertung der Karte">
      <div class="flex flex-col">
        <span class="font-mono text-2xs uppercase tracking-[.06em] text-white/70">{{ title() }}</span>
        <p class="mt-1 flex flex-wrap items-baseline gap-1.5"><span class="text-2xl font-bold leading-8 tabular-nums">{{ figure().value }}</span><span class="text-xs text-white/70">{{ figure().unit }}</span></p>
        <p class="text-xs text-white/70">{{ figure().hint }}</p>
        <div class="mt-2 flex flex-col gap-0.5">
          @for (row of rows(); track row.key) {
            <button type="button" class="relative flex h-7 items-center justify-between gap-2 overflow-hidden rounded-md px-2 text-left text-xs transition-colors hover:bg-white/10 disabled:pointer-events-none" [class]="!row.count ? 'opacity-50' : focus()?.key === row.key ? 'bg-white/20' : ''" [disabled]="!row.count" [hlmTooltipTrigger]="row.title" position="left" (click)="toggle('bin', row.key)">
              <span class="absolute bottom-0 left-2 h-0.5 rounded-[1px]" [style.width]="'calc((100% - 1rem) * ' + row.width / 100 + ')'" [style.background-color]="row.color" aria-hidden="true"></span>
              <span class="relative flex min-w-0 items-center gap-2"><span class="size-2 shrink-0 rounded-[2px]" [style.background-color]="row.color" aria-hidden="true"></span><span class="truncate">{{ row.label }}</span></span>
              <span class="relative font-mono">{{ row.count | number: '1.0-0' : 'de-DE' }}</span>
            </button>
          }
          @if (withoutValue()) { <p class="px-2 pt-1 text-xs text-white/70">{{ withoutValue() | number: '1.0-0' : 'de-DE' }} noch ohne Wert</p> }
        </div>
      </div>

      @if (streets().length) {
        <div class="flex flex-col border-t border-white/10 pt-3">
          <span class="font-mono text-2xs uppercase tracking-[.06em] text-white/70">Stärkste Straßen</span>
          <div class="mt-1.5 flex flex-col gap-0.5">
            @for (row of streets(); track row.street) {
              <button type="button" class="relative flex h-7 items-center justify-between gap-2 overflow-hidden rounded-md px-2 text-left text-xs transition-colors hover:bg-white/10" [class]="focus()?.key === row.street ? 'bg-white/20' : ''" [hlmTooltipTrigger]="row.plants + (row.plants === 1 ? ' Anlage' : ' Anlagen') + ' mit zusammen ' + (row.kwp | number: '1.1-1' : 'de-DE') + ' kWp. Klick zeigt sie auf der Karte.'" position="left" (click)="toggle('street', row.street)">
                <span class="absolute bottom-0 left-2 h-0.5 rounded-[1px] bg-chart-1" [style.width]="'calc((100% - 1rem) * ' + row.width / 100 + ')'" aria-hidden="true"></span>
                <span class="relative truncate">{{ row.street }}</span>
                <span class="relative font-mono">{{ row.kwp | number: '1.0-0' : 'de-DE' }} kWp</span>
              </button>
            }
          </div>
        </div>
      }
    </aside>
  </div>
</section>
